export default {
    /**
        Checkout.vue
     */
    isChangeOrderDetailsOpen: state => Boolean(state.basket.delivery_comments),
    isBillingDetailsOpen: state => Boolean(state.basket.po_number),
}
